import styled from 'styled-components';

export const NewAddressSearchContainer = styled.div`
  display: flex;
  flex-direction: column;

  .no-results {
    padding: 1em;
    color: red;
  }
`;
